//@flow
import React from 'react';
import { ProductVersions } from 'components/organisms/productVersions';
import { ProductVersionsMobile } from 'components/organisms/productVersionsMobile';
import { useViewport } from 'components/templates/viewportProvider';
import type { VersionType } from 'types/product';

type Props = {
  data: {
    data: Array<VersionType>,
    onBrochureClick: () => void,
  },
};
export const ProductVariationsSection = (props: Props) => {
  const { isMobile } = useViewport();
  const { data } = props;
  const { type } = props.data;
  if (!data.data || data.data.length === 0) {
    return null;
  }
  return (
    <div id={'variations'}>
      {isMobile ? (
        <div className="product">
          <ProductVersionsMobile versions={data.data} pdfUrl={data.pdfUrl} type={type}/>
        </div>
      ) : (
        <ProductVersions
          versions={data.data}
          productName={data.productName}
          pdfUrl={data.pdfUrl}
          type={type}
        />
      )}
    </div>
  );
};
